import { useMutation } from '@apollo/client';
import { stagingOptions } from 'constants/apollo';
import { UNASSIGN_ORDER } from 'api/mutations/AssignShipmentMutation';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

export const useUnassignCourier = ({ clearUp = () => { }, selectedShipmentIds, selectedShipments }) => {
    const [handleGqlUnassign, { data, loading, error }] =
        useMutation(UNASSIGN_ORDER, { ...stagingOptions, fetchPolicy: "network-only" });

    useEffect(() => {
        if (data) {
            if (data?.unassignOrdersFromShipment) {
                try {
                    toast.success("Order unassigned successfully");
                    const { orders, couriers } = data.unassignOrdersFromShipment;
                    clearUp({ orders, courier: couriers[0] });
                } catch (data) {
                    toast.error("Order can not be unassigned");
                }
            } else {
                toast.error("Order can not be unassigned");
            }
        }
    }, [data])

    function handleUnassignCourier() {
        if (selectedShipmentIds.length > 0) {
            const confirmed = window.confirm("Are you sure you want to unassign the selected shipments?");
            if (confirmed) {
                let invalidIds = [];
                for (const shipment of selectedShipments) {
                    if (shipment.orderStatus != 'picked_up') {
                        invalidIds.push(shipment.id);
                    }
                }
                if (invalidIds.length == 0) {
                    toast.info("Unassigning order...");
                    let orderIds = []
                    selectedShipmentIds.forEach((shipmentId) => {
                        orderIds.push(Number(shipmentId))
                    });
                    handleGqlUnassign({
                        variables: {
                            input: {
                                orderIds
                            },
                        },
                    })
                } else {
                    toast.error(`Orders with IDs ${invalidIds.join(' ')} are not assigned to any shipment.`);
                }
            }
        } else {
            toast.error("Select at least one order!");
        }
    }

    return { handleUnassignCourier }
}
